<template>
  <j-modal :title="title" :width="600" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false"
    :body-style="{ height: '380px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk" @cancel="handleCancel"
    :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <div>
        <div style="display: flex;">
          <div>
            <div>
              <a-form-model ref="form" layout="horizontal" :model="userInfo" :colon="false">
                <a-row :gutter="24">
                  <a-col :span="24">
                    <a-form-model-item :label="$t('选择评价员工')" :labelCol="{span:5}" :wrapperCol="{span: 19}">
                      <a-select v-model="userInfo.number" :placeholder="$t('请选择评价员工')" style="width: 300px;">
                        <a-select-option :value="item.number" v-for="item in userList">{{item.name}}</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="24">
                    <a-form-model-item :label="$t('用户评价信息')" :labelCol="{span:5}" :wrapperCol="{span: 19}">
                      <div style="border: 1px solid #d9d9d9;border-radius: 4px;;width: 300px;height: 32px;padding: 0 11px;line-height: 30px;margin-top: 5px;">
                        {{[$t('暂无评价'),$t('非常满意'),$t('满意'),$t('不满意'),'',$t('评价中...')][userInfo.evaluate]}}
                      </div>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-form-model>
            </div>
          </div>
        </div>
        <div style="display: flex;justify-content: center;">
          <a-button type="primary" @click="onEvaluate">
              {{ $t('发送评价') }}
          </a-button>
        </div>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import Vue from 'vue'
  export default {
    name: 'userEvaluateModal',
    components: {
      DetailList,
      DetailListItem,
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        userInfo: {},
        userList: [
          {name:'李思思',number:'444444',path:'D:\\cat.jpg',img:'cat.jpg'},
          {name:'司理理',number:'777777',path:'D:\\face.jpg',img:'face.jpg'},
          {name:'丝丽思',number:'888888',path:'D:\\scan1.jpg',img:'scan1.jpg'},
        ]
      }
    },
    methods: {
      init(row) {
        this.title = this.$t('评价');
        this.visible = true;
        this.userInfo = {
          evaluate: 0,
        };
        this.initWebSocket();
      },
      handleOk() {
        this.$emit('ok', this.userInfo);
        this.close();
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      onEvaluate(){
        if(this.userInfo.number){
          this.$message.success(this.$t('发送评价中，请稍等！'))
          this.$set(this.userInfo,'evaluate',5);
          var uObj = this.userList.find(u=>u.number == this.userInfo.number);
          let json1 = {"Type":"5","Method":"star_DownHeadFile","nPort":"0","nBaud":"9600","cBp":"0","szFilePath":uObj.path,"szFileName":uObj.img};
          this.websocketSend(JSON.stringify(json1));
          setTimeout(()=>{
            let json = {"Type":"5","Method":"star_StartEvaluate","nPort":"0","nBaud":"9600","cBp":"0","szTellerName":uObj.name,"szTellerNo":uObj.number,"nStarLevel":"6","szFileName":uObj.img,"nTimeout":"60","nVoiceType":"2","szVoice":"语音测试","szEvaInfo":"标题测试","nShowTime":"5","szOperInfo":"感谢您的评价"}
            this.websocketSend(JSON.stringify(json));
          },5000)
        }else{
          this.$message.warning(this.$t('请先选择要评价的员工！'))
        }
      },
      // websocket消息通知开始
      initWebSocket() {
        // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
        var userId = this.$store.getters.userInfo.id;
        // var url = window._CONFIG['domianURL'].replace("https://", "wss://").replace("http://", "ws://") + "/websocket/" + userId;
        // var url = 'ws://localhost:19998/'
        // var url = 'http://172.16.8.137:19998/'
        var url = 'http://127.0.0.1:19998/'

        //update-begin-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
        let token = Vue.ls.get('ACCESS_TOKEN')

        this.websocket = new WebSocket(url);
        //update-end-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
        this.websocket.onopen = this.websocketOnopen;
        this.websocket.onerror = this.websocketOnerror;
        this.websocket.onmessage = this.websocketOnmessage;
        this.websocket.onclose = this.websocketOnclose;
      },
      websocketOnopen() {
        console.log("WebSocket消息通知layout连接成功");
        //心跳检测重置
        // this.heartCheck.reset().start();
      },
      websocketOnerror(e) {
        console.log("WebSocket连接发生错误，第%s次", this.wsConnectErrorTime);

        this.wsConnectErrorTime = this.wsConnectErrorTime + 1;
        if (this.wsConnectErrorTime > 5) {
          console.log("WebSocket连接错误超过5次，就不再重新连了！");
          this.lockReconnect = true
          return;
        }
        // this.reconnect();
      },
      websocketOnmessage(e) {
        let data = JSON.parse(e.data); //解析json字符串
        console.log("WebSocket消息通知layout收到消息", data);
        // 按照实际需求处理消息（即只推送给含有特定消息类型的用户）
        // if(this.messageType.findIndex(item => item == data.port) == -1) {
        //   return
        // }
        console.log(data);
        if (data.Type == 5 && data.Method == "star_StartEvaluate") { // 评价结果
          if(data.ret == 0){
            data.nResult
            this.userInfo.evaluate = data.nResult;
          }else{
            this.userInfo.evaluate = 0;
            this.$message.error(this.$t('评价错误！'))
          }
        }
      },
      websocketOnclose(e) {
        console.log("connection closed (" + e + ")");
        if (e) {
          console.log("connection closed (" + e.code + ")");
        }
        // this.reconnect();
      },
      websocketSend(text) { // 数据发送
        try {
          this.websocket.send(text);
        } catch (err) {
          console.log("send failed (" + err.code + ")");
        }
      },
    }
  }
</script>
<style scoped>
  /deep/.detail-list .content {
    line-height: normal;
  }
</style>